export enum PatientType {
    VAPER = "vaper",
    SMOKER = "smoker"
}